import BaseService from "./base";

export default class AccountService extends BaseService {
  resource = "/account"

  constructor(token, baseUrl) {
    super(token, baseUrl)
  }

  login(username, password) {
    return this.transport.post('/login', {username, password});
  }


};
